<script setup lang="ts">
import { InternalDataTableHeader } from './types';

defineProps<{
  column: InternalDataTableHeader;
  toggleSort: (column: InternalDataTableHeader) => void;
  getSortIcon: (
    column: InternalDataTableHeader,
  ) => string | (string | [string, number])[] | (new () => any);
}>();
</script>

<template>
  <div class="v-data-table-header__content align-center">
    <span>
      <slot />
    </span>
    <v-icon
      v-if="column.sortable"
      key="icon"
      class="v-data-table-header__sort-icon"
      :icon="getSortIcon(column)"
    ></v-icon>
  </div>
</template>
